/**
 * V75Popup - V75 info popup with blue/gold broadcast theme
 */

export function V75Popup({ v75Visible, v75Text, v75Exiting }) {
  if (!v75Visible || !v75Text) return null;

  return (
    <div
      data-testid="v75-popup"
      style={{
        position: 'absolute',
        bottom: '85px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 45,
        animation: v75Exiting ? 'messageExit 0.8s ease-in forwards' : 'messageEnter 0.8s ease-out forwards',
      }}
    >
      <div style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '24px',
        backgroundColor: '#050F23',
        minWidth: '680px',
        maxWidth: '1105px',
        border: '2px solid var(--theme-panel-border)',
        boxShadow: `0 0 50px rgba(var(--theme-accent-rgb), 0.25), 0 34px 85px rgba(0,0,0,0.5)`,
        overflow: 'visible',
        position: 'relative',
      }}>
        {/* V75 Logo */}
        <img
          src="/assets/v75-logo.png"
          alt="V75"
          style={{
            position: 'absolute',
            top: '-68px', left: '-51px',
            width: '243px', height: '192px',
            objectFit: 'contain',
            filter: 'drop-shadow(3px 3px 10px rgba(0,0,0,0.5))',
            zIndex: 2,
          }}
        />
        <div style={{  padding: '34px 75px', textAlign: 'center' }}>
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: '1.1rem', fontWeight: 600, color: '#FFD700',
            textTransform: 'uppercase', letterSpacing: '7px', marginBottom: '17px',
            animation: v75Exiting ? 'none' : 'messageLabelFade 0.8s ease-out 0.3s both',
          }}>
            V75 Informasjon
          </div>
          <div style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '2.38rem', fontWeight: 600, color: '#FFFFFF',
            lineHeight: 1.4, whiteSpace: 'pre-wrap',
            textShadow: '0 3px 14px rgba(0,0,0,0.3)',
            animation: v75Exiting ? 'none' : 'messageTextReveal 0.6s ease-out 0.4s both',
          }}>
            {v75Text}
          </div>
        </div>
      </div>
    </div>
  );
}
